import React from 'react';
import Footer from '../../components/footer';
import { useMoralis } from 'react-moralis';
import { useEffect, useState } from 'react'
import { Link } from '@reach/router';
import CollectionList from './CollectionList'
import { useWeb3React } from '@web3-react/core';

const AllCollections = () => {

  const { Moralis, isInitialized } = useMoralis()
  const [collections, setCollections] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [isAdmin, setIsAdmin] = useState(false)
  const { account } = useWeb3React()

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(async () => {

    if (isInitialized) {

      if (isAdmin) {
        try {
          setIsLoading(true)
          const Collections = Moralis.Object.extend("Collections")
          const query = new Moralis.Query(Collections)
          const result = await query.find()
          setCollections(result)
          setIsLoading(false)
        } catch (error) {
          setIsLoading(false)
          console.error('MORALIS ERROR : error while fetching marketplace data', error)
        }
      } else {
        try {
          setIsLoading(true)
          const Collections = Moralis.Object.extend("Collections")
          const query = new Moralis.Query(Collections)
          query.equalTo('status', 'active')
          const result = await query.find()
          setCollections(result)
          setIsLoading(false)
        } catch (error) {
          setIsLoading(false)
          console.error('MORALIS ERROR : error while fetching marketplace data', error)
        }
      }

    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isInitialized, isAdmin])

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(async () => {
    const adminAddressLowerCase = []
    const adminAddress = process.env.REACT_APP_ADMIN_ADRS.split(',')

    if (adminAddress && adminAddress.length > 0) {
      adminAddress.forEach(address => {
        adminAddressLowerCase.push(address.toLowerCase())
      })
    }

    if (account) {
      const currentUserAddress = account.toLowerCase()
      const result = adminAddressLowerCase.includes(currentUserAddress)
      if (result) {
        setIsAdmin(true)
      } else {
        setIsAdmin(false)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [account])

  useEffect(() => {
    console.log('collections', collections);
  }, [collections])

  return (
    <div>
      <section className='container'></section>
          {
            isLoading ? (
              <div className='col-lg-12'>
                <div className='loading-container mb-4'>
                  <div className="spinner-grow" role="status">
                    <span className="sr-only">Loading...</span>
                  </div>
                </div>
              </div>
            ) : (
              <CollectionList
                isLoading={isLoading}
                collections={collections}
              />
            )
          }

      <Footer />
    </div>);
}
export default AllCollections;